function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

// http://alphagov.github.io/govuk_template/example-proposition-menu.html
// TODO: this component is a work in progress and needs to more closely match existing examples
// TODO: is TopNav the right name? What's it called in other GDS styles/patterns?
// (The name Header is ambiguous)
import React from 'react';
import PropTypes from 'prop-types';
import { BLACK, WHITE } from 'govuk-colours';
import TopNavWrapper from './atoms/top-nav-wrapper';
import TopNavInner from './atoms/top-nav-inner';
import BottomNavWrapper from './atoms/bottom-nav-wrapper';
import Company from './atoms/company';
import LogoSearchWrapper from './atoms/logo-search-wrapper';
import RightHandSide from './atoms/right-hand-side';
import SearchWrapper from './atoms/search-wrapper';
import UnorderedList from './atoms/unordered-list';
import ListItem from './atoms/list-item';
import MenuButton from './atoms/menu-button/';
import IconTitle from './atoms/icon-title';

var TopNav = function TopNav(_ref) {
  var active = _ref.active,
      bgColor = _ref.bgColor,
      color = _ref.color,
      company = _ref.company,
      serviceTitle = _ref.serviceTitle,
      search = _ref.search,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["active", "bgColor", "color", "company", "serviceTitle", "search", "children"]);

  return React.createElement(React.Fragment, null, React.createElement(TopNavWrapper, _extends({
    bgColor: bgColor,
    color: color
  }, props), React.createElement(TopNavInner, null, React.createElement(LogoSearchWrapper, null, React.createElement(Company, null, company), search && React.createElement(SearchWrapper, null, search)), React.createElement(RightHandSide, null, serviceTitle, children && React.createElement(React.Fragment, null, React.createElement(MenuButton, null), React.createElement(UnorderedList, {
    serviceTitle: serviceTitle
  }, children.length && children.map ? children.map(function (child, i) {
    return child && (child.length || child.props) ? React.createElement(ListItem, {
      key: child.key || i
    }, child) : null;
  }) : React.createElement(ListItem, null, children)))))), React.createElement(BottomNavWrapper, null));
};

TopNav.defaultProps = {
  active: undefined,
  bgColor: BLACK,
  color: WHITE,
  company: undefined,
  serviceTitle: undefined,
  search: false,
  children: undefined
};
TopNav.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.number,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  company: PropTypes.node,
  serviceTitle: PropTypes.node,
  search: PropTypes.node,
  children: PropTypes.node
} : {};
TopNav.IconTitle = IconTitle;
export default TopNav;
import _asAnchor from './asAnchor';
export { _asAnchor as asAnchor };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/index.js
// module id = 108
// module chunks = 0